import React, { ReactNode } from 'react';
import { Tooltip } from '@ghq-abi/design-system';

import { useClickableTooltip } from '~/shared/hooks/useClickableTooltip';

import { ClickableTooltipTrigger } from '../../ClickableTooltipTrigger';
import { InfoCircleFilled } from '../../icons';

type InfoTooltipProps = {
  tooltipText: string;
  icon?: ReactNode;
};
export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  tooltipText,
  icon: Icon,
}) => {
  const { rootTooltipProps, openTooltip } = useClickableTooltip();

  return (
    <Tooltip showArrow content={tooltipText} {...rootTooltipProps}>
      <ClickableTooltipTrigger
        onClick={openTooltip}
        onTouchEnd={e => e.stopPropagation()}
      >
        {Icon || <InfoCircleFilled color="#191F2E" />}
      </ClickableTooltipTrigger>
    </Tooltip>
  );
};
